import { TFactoryProductLineEfficiencyActions } from './product-line-efficiency.actions';
import {
  TFactoryProductLineEfficiencyActionType,
  TFactoryProductLineEfficiencyState,
} from './product-line-efficiency.models';

export const initialState: TFactoryProductLineEfficiencyState = {
  factoryLineEfficiencyInfo: null,
};

export function factoryProductLineEfficiencyReducer(
  state = initialState,
  action: TFactoryProductLineEfficiencyActions,
): TFactoryProductLineEfficiencyState {
  switch (action.type) {
    case TFactoryProductLineEfficiencyActionType.GetFactoryProductLineEfficiencySuccess:
      return {
        ...state,
        factoryLineEfficiencyInfo: action.factoryProductLineEfficiencyRes,
      };
    default:
      return state;
  }
}
